/// <amd-module name="Build/Admin/AgentCloudsList/Components/CreateAgentCloudPanel" />
import * as React from "react";

import { TaskAgentCloud } from "DistributedTask/Client/Contracts/TaskAgent";

import { IVssComponentContext } from "VSS/Platform/Layout";

import { Panel } from "VSSUI/Panel";
import { TextField } from "VSSUI/TextField";

import { AgentCloudsListActionCreator } from "Build/Admin/AgentCloudsList/Actions/AgentCloudsListActionCreator";

import * as Resources from "Build/Admin/AgentCloudsList/Resources";

export interface ICreateAgentCloudPanelProps {
    actionCreator: AgentCloudsListActionCreator;
    isOpen: boolean;
    onDismiss(): void;
}

interface ICreateAgentCloudPanelState {
    acquireAgentEndpoint?: string;
    agentCloudName?: string;
    agentCloudType?: string;
    getAccountParallelismEndpoint?: string;
    getAgentDefinitionEndpoint?: string;
    getAgentRequestStatusEndpoint?: string;
    maxParallelism?: string;
    releaseAgentEndpoint?: string;
    sharedSecret?: string;
}

export class CreateAgentCloudPanel extends React.Component<ICreateAgentCloudPanelProps, ICreateAgentCloudPanelState> {

    constructor(props: ICreateAgentCloudPanelProps, context: IVssComponentContext) {
        super(props, context);
        this.state = this._getStateFromStores();
    }

    public render(): JSX.Element | null {
        if (this.props.isOpen) {
            return (
                <Panel
                    className="pipelines-create-agent-cloud-panel"
                    titleProps={{ text: Resources.CreateNewAgentCloudTitle }}
                    description={Resources.CreateNewAgentCloudDescription}
                    onDismiss={this.props.onDismiss}
                    footerButtonProps={[
                        {
                            text: Resources.Create,
                            primary: true,
                            onClick: this._okOnClick,
                            disabled: this._shouldDisableSubmitButton()
                        }
                    ]}>
                    <div>
                        <TextField
                            value={this.state.agentCloudName}
                            label={Resources.NewAgentCloudNameLabel}
                            onChange={(ev, agentCloudName) => (this.setState({ agentCloudName }))} />
                        <TextField
                            value={this.state.agentCloudType}
                            label={Resources.NewAgentCloudTypeLabel}
                            onChange={(ev, agentCloudType) => (this.setState({ agentCloudType }))} />
                        <TextField
                            value={this.state.acquireAgentEndpoint}
                            label={Resources.AcquireAgentEndpointLabel}
                            onChange={(ev, acquireAgentEndpoint) => (this.setState({ acquireAgentEndpoint }))} />
                        <TextField
                            value={this.state.releaseAgentEndpoint}
                            label={Resources.ReleaseAgentEndpointLabel}
                            onChange={(ev, releaseAgentEndpoint) => (this.setState({ releaseAgentEndpoint }))} />
                        <TextField
                            value={this.state.getAgentDefinitionEndpoint}
                            label={Resources.GetAgentDefinitionEndpointLabel}
                            onChange={(ev, getAgentDefinitionEndpoint) => (this.setState({ getAgentDefinitionEndpoint }))} />
                        <TextField
                            value={this.state.getAgentRequestStatusEndpoint}
                            label={Resources.GetAgentRequestStatusEndpointLabel}
                            onChange={(ev, getAgentRequestStatusEndpoint) => (this.setState({ getAgentRequestStatusEndpoint }))} />
                        <TextField
                            value={this.state.getAccountParallelismEndpoint}
                            label={Resources.GetAccountParallelismEndpointLabel}
                            onChange={(ev, getAccountParallelismEndpoint) => (this.setState({ getAccountParallelismEndpoint }))} />
                        <TextField
                            value={this.state.maxParallelism}
                            label={Resources.MaxParallelismLabel}
                            onChange={(ev, maxParallelism) => (this.setState({ maxParallelism }))} />
                        <TextField
                            value={this.state.sharedSecret}
                            label={Resources.SharedSecretLabel}
                            onChange={(ev, sharedSecret) => (this.setState({ sharedSecret }))} />
                    </div>
                </Panel>
            );
        }

        return null;
    }

    private _okOnClick = (): void => {
        if (!!this.state.agentCloudName &&
            !!this.state.agentCloudType &&
            !!this.state.acquireAgentEndpoint &&
            !!this.state.releaseAgentEndpoint &&
            !!this.state.getAgentDefinitionEndpoint &&
            !!this.state.getAgentRequestStatusEndpoint &&
            !!this.state.sharedSecret) {

            const agentCloud: TaskAgentCloud = {
                name: this.state.agentCloudName,
                type: this.state.agentCloudType,
                acquireAgentEndpoint: this.state.acquireAgentEndpoint,
                getAccountParallelismEndpoint: this.state.getAccountParallelismEndpoint,
                getAgentDefinitionEndpoint: this.state.getAgentDefinitionEndpoint,
                getAgentRequestStatusEndpoint: this.state.getAgentRequestStatusEndpoint,
                releaseAgentEndpoint: this.state.releaseAgentEndpoint,
                sharedSecret: this.state.sharedSecret
            } as TaskAgentCloud;

            if (this.state.maxParallelism) {
                agentCloud.maxParallelism = parseInt(this.state.maxParallelism, 10);
            }

            this.props.actionCreator.addAgentCloud(agentCloud);
            this.props.onDismiss();
        }
    }

    private _cancelOnClick = (): void => {
        this.props.onDismiss();
        this.setState(this._getStateFromStores());
    }

    private _shouldDisableSubmitButton = (): boolean => {
        return !this._validInputs();
    }

    private _validInputs(): boolean {
        return !!this.state.agentCloudName &&
            !!this.state.agentCloudType &&
            !!this.state.acquireAgentEndpoint &&
            !!this.state.releaseAgentEndpoint &&
            !!this.state.getAgentDefinitionEndpoint &&
            !!this.state.getAgentRequestStatusEndpoint &&
            !!this.state.sharedSecret;
    }

    private _getStateFromStores = (): ICreateAgentCloudPanelState => {
        // This is used on panel initialization, and to reset the panel state on open/close
        // so some of the panel's fields are set to their default values below.
        // The panel's fields are set by setState calls in the child component callbacks in the render function.
        return {
            acquireAgentEndpoint: undefined,
            agentCloudName: undefined,
            agentCloudType: undefined,
            getAccountParallelismEndpoint: undefined,
            getAgentDefinitionEndpoint: undefined,
            getAgentRequestStatusEndpoint: undefined,
            maxParallelism: undefined,
            releaseAgentEndpoint: undefined,
            sharedSecret: undefined,
        };
    }
}
